export default "__VITE_ASSET__DU7f2KrD__"